
// export Alert from './alert'
//FLH 2D Move 2D Table To YXYWeb
export Button from "./button"
export Cascader from './cascader'
export CheckBox from './checkbox'
export CheckboxGroup from "./checkboxgroup"
export Col from "./col"
export DatePicker from "./datepicker"
export TimePicker from './timepicker'
export DateTimePicker from './datetimepicker'
export TimeRangePicker from './timerangepicker'
export RangePicker from './rangepicker'
export DropdownButton from "./dropdownbutton"
export Dropdown from './dropdown';
export Input from './input'
export InputNumber from './inputnumber'
export Money from './inputnumber'
export Price from './inputnumber'
export Label from './label'
export Text from './text'
export Textarea from './textarea'
// export Progress from "./progress"
export Radio from "./radio"
// export Rate from "./rate"
export Refer from "./refer"
export Row from "./row"
export Select from './select'
// export Steps from "./steps"
export Switch from "./switch"
export Table from "./table"
export Tag from "./tag"
// export Tooltip from "./tooltip"
// export Transfer from "./transfer"
export Tree from "./tree"
export RichText from './richtext'
// export Selectgroup from '../Contacts/selectgroup'
// export GroupBlock from './groupblock'
export Menu from './menu'
// export QuickTag from './quickTab'
// export NewTabs from '../NewTabs'
// export Map from './map'
export Map from './amap'
// export Map from '../meta/HotAreaMapDesign'
// export Map from '../meta/HotAreaMapDisplay'
export Tag2 from "./tag2"
export PredicateDatePicker from './predicatedatepicker';
export TreeRefer from './treerefer'
export Span from './span'
export Attachment from '../file-upload'
export SwitchLabel from './switchlabel'
export ListRefer from './listrefer'
export Avatar from './avatar'
// export BInputNum from './binputnum'
export TextImport from './textimport'
export InputFloat from './inputfloat'
export CheckRadio from './checkradio'
export Password from './password';
export TreeTable from './treetable'
export ColorPicker from './colorpicker'
export CheckboxEnum from './checkboxenum'
export TagGroup from './taggroup'
export Signature from './sigCanvas'
export TagRefer from './tagrefer'
export MsgCode from './msgcode'
export TagArea from './tagarea'
export Stepper from './stepper'
export SpecConfig from './specconfig'
export InputSearch from './inputsearch'
export Table2D from './table2D'
export FieldHelp from './fieldHelp'
export DatePicker_Design from './datepicker_design'
export DatePicker_Full from './datepicker_full'
export DelaySelect from './delaySelect'


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/index.jsx